export default {
    "dataIterator": {
        "rowsPerPageText": "Položek na stránku:",
        "rowsPerPageAll": "Všechny",
        "pageText": "{0}-{1} of {2}",
        "noResultsText": "Nenalezeny odpovídající záznamy",
        "nextPage": "Další stránka",
        "prevPage": "Předchozí stránka"
    },
    "dataTable": {
        "rowsPerPageText": "5ádek na stránku:"
    },
    "noDataText": "Nejsou dostupná žádná data",

    "app": {
        "name": "BZUCO Inspector",
        "reseted": "Vstupenky byly resetované...",
        "networkError": "Chyba komunikace se serverem, zkontrolujte prosím přípojení k internetu...",
        "networkNotAvailable": "Nepřipojeno",
    },
    "menu": {
        "test": "Test čtečky kódů",
        "settings": "Nastavení",
        "admin": "Administrace",
        "resetTickets": "Reset vstupenek",
        "resetState": "Reset stavu aplikace",
        "logout": "Odhlásit"
    },
    "home": {
        "login": "Přihlásit se",
        "lastEvent": "Poslední načtená akce",
        "chooseEvent": "Vyberte akci"
    },
    "event": {
        "chooseEvent": "Vyberte akci",
        "chooseEventPast": "Proběhlé akce",
        "confirm": "Potvrdit výběr akcí",
        "showPast": "zobrazit proběhlé akce",
    },
    // "checkpoint": {
    //     "chooseCheckpoint": "Vyberte kontrolní místo",
    //     "set0": "bez sad",
    //     "set1": "1 sada",
    //     "set2": "{0} sady",
    //     "set5": "{0} sad",
    // },
    "zone": {
        "chooseZone": "Vyberte zónu / zóny",
        "confirm": "Potvrdit výběr zón"
    },
    "ticketsets": {
        "chooseTicketsets": "Vyberte sadu vstupenek",
        "selectAll": "Vybrat všechny",
        "ticketCount": "Počet vstupenek:"
    },
    "scanner": {
        "tickets": "Vstupenek:",
        "startReader": "Spustit čtečku",
        "startReaderDescription": "Prohlížeč potřebuje interakci uživatele pro spuštění systémových zvuků nutných pro upozorňování. Potvrďte prosím tlačítkem \"OK\"",
        "specialWarning": "Upozornění",
        "specialType": "Vstupenka je speciálního typu:",
        "refuse": "Odmítnout",
        "confirm": "Potvrdit",
        "messageSuccess": "Kód {0} úspěšně uplatněn",
        "messageSuccessPrice": "Kód {0} úspěšně uplatněn<br /><big>Cena: <b>{1}</b></big>",
        "messageSuccessTicketsetPrice": "Kód {0} úspěšně uplatněn<br /><big>Sada: <b>{1} / {2}</b></big>",
        "messageSuccessTicketset": "Kód {0} úspěšně uplatněn<br /><big>Sada vst.: <b>{1}</b></big>",
        "messageSuccessEvent": "Kód {0} úspěšně uplatněn<br /><big>Akce: <b>{1}</b>, sada: {2}</big>",
        "messageSuccessNosend": "Kód {0} úspěšně uplatněn (neodesláno)",
        "messageRead": "Byl načten kód {0}",
        "messageUsed": "Kód {0} byl již použit",
        "messageNotUsable": "Kód {0} není možné použít", // "Kód {0} byl již použit",
        "messageUnsend": "Kód {0} byl již použit (mnou, neodeslán)",
        "messageNotFound": "Kód <b>{0}</b> nenalezen v načtených vstupenkách",
        "messageBadSlot": "Kód {0} není platný pro tuto zónu/slot",
        "messageExtra1": "použit na zařízení: <b>{0}</b>, datum: <b>{1}</b>",
        "manualTitle": "Ruční vložení kódu",
        "loading": "nahrávám vstupenky...",
        "nfcNotFound": "Žádná ze vstupenek na kartě není platná"
    },
    "login": {
        "title": "Přihlášení do aplikace",
        "username": "Přihlašovací jméno",
        "password": "Heslo",
        "login": "Přihlásit"
    },
    "settings": {
        "title": "Nastavení",
        "sound": "Zvuk",
        "soundSub": "Zapnutí zvukových upozornění",
        "camera": "Kamera",
        "nfc_heading": "NFC",
        "nfc": "Číst NFC tagy",
        "language": "Jazyk",
        "langCs": "Česky",
        "langEn": "Anglicky",
        "qTitle": "Detailní nastavení čtěčky",
        "qPatchSize": "Velikost dekódovacího okna",
        "qFrequency": "Frekvence dekódování",
        "groupDisplay": "Zobrazení skupiny / kategorie při kontrole",
        "groupDisplayNone": "Nezobrazovat nic",
        "groupDisplayTicketset": "Zobrazit sady vstupenek",
        "groupDisplayTicketsetPrice": "Zobrazit sady vstupenek a cenovou hladinu",
        "groupDisplayPrice": "Zobrazit cenovou hladinu",
        "groupDisplayEvent": "Zobrazit jméno události a sadu",
        "olderEvents": "Jak dlouho zobrazovat události po jejich ukončení",
        "olderEventsWeek": "Týden",
        "olderEventsMonth": "Měsíc",
        "olderEvents3Month": "3 mesíce",
        "olderEvents6Month": "6 měsíců",
        "olderEventsYear": "1 rok",
        "olderEventsAll": "Zobrazit všechny",
        "olderEventsAllList": "všechny",
        "showTicketCount": "Zobrazit počet vstupenek",
        "showStatistics": "Zobrazit statistiky"
    },
    "statistics": {
        "title": "Statistiky použití vstupenek",
        "zone": "Zóna",
        "today": "Dnes",
        "total": "Celkem",
        "refresh": "Obnovit data"
    }
}
